import React from 'react';
import AlignCenter from '../../pages/AlignCenter';
import { goSingleStory } from '../../utils';
import StoryDisplay from '../StoryDisplay';

const Stories = ({ item, classes, hoverStyle, storyImageLoaded, index, navigate, eager }) => {
	return (
		<div className={hoverStyle.block1}>
			<AlignCenter>
				{item && item.image && (
					<StoryDisplay
						story={item}
						onClick={() => goSingleStory(item.slug, navigate)}
						onLoad={storyImageLoaded}
						eager={eager}
					/>
				)}
			</AlignCenter>
		</div>
	);
};

export default Stories;
